import styled from 'styled-components';

import { colors } from 'styles/theme/colors';

type Props = { label: string; value: number; max: number };

// Determinate only: a run always knows its total, so there is never a reason for a spinner here.
// Not in the design system yet.
export default function RunProgressBar({ label, value, max }: Props) {
  const percent = max > 0 ? Math.round((100 * value) / max) : 0;

  return (
    <Container role='progressbar' aria-valuemin={0} aria-valuemax={max} aria-valuenow={value} aria-label={label}>
      <Line>
        <span>{label}</span>
        <Muted>{percent}%</Muted>
      </Line>
      <Track>
        <Fill $percent={percent} />
      </Track>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Line = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  font-size: 14px;
  line-height: 22px;
`;

const Muted = styled.span`
  color: ${colors.black75};
`;

const Track = styled.div`
  height: 8px;
  border-radius: 4px;
  background: ${colors.black10};
  overflow: hidden;
`;

const Fill = styled.div<{ $percent: number }>`
  height: 100%;
  width: ${({ $percent }) => $percent}%;
  background: ${colors.blue100};
  border-radius: 4px;
  transition: width 240ms ease;
`;
